import type { TranslationDict } from '../en';

const de: TranslationDict = {
  'header.buy': 'Kaufen',
  'header.sell': 'Verkaufen',
  'spend.label': 'Du zahlst',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',
  'receive.label': 'Du erhältst',
  'payment.label': 'Zahlungsmethode',
  'payment.select': 'Auswählen',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'Keine Zahlungsmethoden für dieses Paar',
  'wallet.label': 'Empfangs-Wallet-Adresse',
  'wallet.placeholderBuy': 'Gib deine Empfangsadresse ein',
  'wallet.placeholderSell': 'Gib deine Sendeadresse ein',
  'wallet.validating': 'Adresse wird überprüft...',
  'wallet.invalid': 'Gib eine gültige Wallet-Adresse ein',
  'wallet.invalidServer': 'Ungültige Wallet-Adresse',
  'cta.buy': '{crypto} kaufen',
  'cta.sell': '{crypto} verkaufen',
  'cta.gettingPrice': 'Besten Preis ermitteln...',
  'cta.processing': 'Wird verarbeitet...',
  'footer.poweredBy': 'Bereitgestellt von ',
  'footer.brand': 'NowRamp',
  'rate.title': 'Kursaufschlüsselung',
  'rate.close': 'Schließen',
  'rate.updatesIn': 'Kurs aktualisiert in 00:{seconds}',
  'rate.noQuote': 'Kein Angebot verfügbar',
  'rate.exchangeRate': 'Wechselkurs',
  'rate.processingFee': 'Bearbeitungsgebühr',
  'rate.networkFee': 'Netzwerkgebühr',
  'rate.provider': 'Anbieter',
  'toast.orderCreated': 'Bestellung erstellt',
  'toast.redirecting': 'Weiterleitung zur Kasse...',
  'toast.orderFailed': 'Bestellung fehlgeschlagen',
  'toast.couldNotCreate': 'Bestellung konnte nicht erstellt werden',
  'toast.quoteError': 'Angebotsfehler',
  'toast.noProviders': 'Keine Anbieter',
  'toast.somethingWrong': 'Etwas ist schiefgelaufen',
  'error.amountZero': 'Der Betrag muss größer als 0 sein',
  'error.minAmountFiat': 'Mindestbetrag ist {min} {currency}',
  'error.minAmountCrypto': 'Mindestbetrag ist {min} {currency}',
  'error.noProviders': 'Keine Anbieter für diese Kombination verfügbar',
  'error.currencyUnavailableBuy': 'Diese Währung ist für Käufe nicht verfügbar',
  'error.currencyUnavailableSell': 'Diese Währung ist für Verkäufe nicht verfügbar',
  'parity.info': 'Dir werden {receiveAmount} {crypto} berechnet, der Rest bis {spendAmount} {fiat} wird deinem {partner}-Konto gutgeschrieben',
  'redirect.secureBadge': 'Sichere Zahlung',
  'redirect.title': 'Zahlung fortsetzen',
  'redirect.description': 'Du wirst zu {gateway} weitergeleitet, um deine Zahlung abzuschließen.',
  'redirect.countdown': 'Weiterleitung in {seconds}...',
  'redirect.openTab': 'ACH in neuem Tab öffnen',
  'redirect.cancel': 'Abbrechen',
  'checkout.noOrder': 'Keine Bestellung gefunden',
  'checkout.goBack': 'Zurück',
  'checkout.expired': 'Bezahlvorgang abgelaufen',
  'checkout.expiredDesc': 'Die Sitzung ist abgelaufen. Bitte versuche es erneut.',
  'checkout.startOver': 'Neu beginnen',
  'checkout.cancel': 'Abbrechen',
  'checkout.loading': 'Bezahlvorgang wird geladen...',
  'checkout.iframeTitle': 'Anbieter-Bezahlvorgang',
  'checkout.widgetTitle': 'Zahlungs-Checkout',
  'checkout.unknownMethod': 'Unbekannte Bezahlmethode',
  'processing.default': 'Deine Bestellung wird verarbeitet...',
  'processing.pending': 'Warten auf Zahlungsbestätigung...',
  'processing.active': 'Deine Transaktion wird verarbeitet...',
  'processing.generic': 'Wird verarbeitet...',
  'processing.checkingStatus': 'Status wird überprüft...',
  'processing.orderId': 'Bestell-ID',
  'processing.provider': 'Anbieter',
  'processing.amount': 'Betrag',
  'processing.receiving': 'Empfang',
  'processing.network': 'Netzwerk',
  'processing.toAddress': 'Zieladresse',
  'processing.usuallyMinutes': 'Dies dauert in der Regel einige Minuten.',
  'processing.safeToClose': 'Du kannst diese Seite bedenkenlos schließen - wir senden dir eine E-Mail, wenn alles abgeschlossen ist.',
  'complete.buyTitle': 'Kauf abgeschlossen!',
  'complete.sellTitle': 'Verkauf abgeschlossen!',
  'complete.buyDesc': 'Deine {crypto} wurden an dein Wallet gesendet.',
  'complete.sellDesc': 'Deine {fiat}-Auszahlung wird verarbeitet.',
  'complete.amountBuy': 'Erhaltener Betrag',
  'complete.amountSell': 'Verkaufter Betrag',
  'complete.paidBuy': 'Gezahlter Betrag',
  'complete.paidSell': 'Auszahlungsbetrag',
  'complete.network': 'Netzwerk',
  'complete.wallet': 'Wallet',
  'complete.transaction': 'Transaktion',
  'complete.provider': 'Anbieter',
  'complete.orderId': 'Bestell-ID',
  'complete.completed': 'Abgeschlossen',
  'complete.viewExplorer': 'Im Explorer ansehen',
  'complete.done': 'Fertig',
  'errorStep.failed': 'Zahlung fehlgeschlagen',
  'errorStep.cancelled': 'Bestellung storniert',
  'errorStep.expired': 'Bestellung abgelaufen',
  'errorStep.refunded': 'Bestellung erstattet',
  'errorStep.unknown': 'Etwas ist schiefgelaufen',
  'errorStep.failedBuy': 'Deine Zahlung konnte nicht verarbeitet werden. Bitte versuche es erneut oder verwende eine andere Zahlungsmethode.',
  'errorStep.failedSell': 'Dein Verkauf konnte nicht verarbeitet werden. Bitte versuche es erneut.',
  'errorStep.cancelledBuy': 'Deine Bestellung wurde storniert. Es wurde keine Zahlung verarbeitet.',
  'errorStep.cancelledSell': 'Dein Verkauf wurde storniert. Es wurden keine Kryptowährungen übertragen.',
  'errorStep.expiredBuy': 'Deine Bestellung ist abgelaufen. Bitte starte einen neuen Kauf.',
  'errorStep.expiredSell': 'Deine Bestellung ist abgelaufen. Bitte starte einen neuen Verkauf.',
  'errorStep.refundedBuy': 'Deine Zahlung wurde erstattet. Die Rückerstattung erscheint innerhalb von 5-10 Werktagen auf deinem Konto.',
  'errorStep.refundedSell': 'Deine Kryptowährungen wurden zurückgegeben. Die Mittel erscheinen in Kürze in deinem Wallet.',
  'errorStep.genericDesc': 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es erneut.',
  'errorStep.orderId': 'Bestell-ID',
  'errorStep.tryAgain': 'Erneut versuchen',
  'errorStep.startOver': 'Neu beginnen',
  'errorStep.return': 'Zurück',
  'errorStep.needHelp': 'Hilfe benötigt? Kontaktiere ',
  'errorStep.reference': 'Referenz: {orderId}',
  'confirm.buyTitle': 'Kauf bestätigen',
  'confirm.sellTitle': 'Verkauf bestätigen',
  'confirm.loading': 'Wird geladen...',
  'confirm.provider': 'Anbieter',
  'confirm.youPay': 'Du zahlst',
  'confirm.youSell': 'Du verkaufst',
  'confirm.youReceive': 'Du erhältst',
  'confirm.wallet': 'Wallet',
  'confirm.network': 'Netzwerk',
  'confirm.refundAddress': 'Rückerstattungsadresse',
  'confirm.parityNote': 'Der berechnete Betrag des Anbieters kann abweichen. Der Rest bis {amount} {crypto} wird deinem {partner}-Konto gutgeschrieben.',
  'confirm.processing': 'Wird verarbeitet...',
  'confirm.confirmPay': 'Bestätigen und zahlen',
  'confirm.confirmSell': 'Bestätigen und verkaufen',
  'confirm.payout': '{currency}-Auszahlung',
  'modal.selectFiat': 'Fiat-Währung auswählen',
  'modal.selectCrypto': 'Kryptowährung auswählen',
  'modal.choosePayment': 'Zahlungsmethode wählen',
  'modal.selectCountry': 'Land auswählen',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'Beliebt',
  'modal.recommended': 'Empfohlen',
  'modal.noCurrencies': 'Keine Währungen gefunden',
  'modal.noPaymentMethods': 'Keine Zahlungsmethoden gefunden',
  'modal.noCountries': 'Keine Länder gefunden',
  'modal.noLanguages': 'No languages found',
  'settings.location': 'Standort',
  'settings.darkMode': 'Dunkelmodus',
  'settings.privacy': 'Datenschutzrichtlinie',
  'settings.terms': 'Nutzungsbedingungen',
  'settings.language': 'Sprache',
  // ─── Additional ───
  'modal.chooseRamp': 'Ramp auswählen',
  'modal.bestPrice': 'Bester Preis',
  'modal.noQuotes': 'Keine Angebote für diese Anfrage verfügbar',
  'modal.noProvidersFound': 'Keine Anbieter gefunden',
  'payment.unavailableFor': 'Keine Zahlungsmethoden für {currency} verfügbar',
  'skeleton.poweredBy': 'Bereitgestellt von NowRamp',
  'error.createOrderFailed': 'Bestellung konnte nicht erstellt werden',
  'errorStep.returnToMerchant': 'Zum Händler zurückkehren',
  'confirm.cryptoOnNetwork': '{crypto} auf {network}',
  'payment.name.card': 'Karte',
  'payment.name.bankTransfer': 'Banküberweisung',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default de;
